import styles from '../../../../../common/preview-block/Preview.module.scss';
import React from 'react';

const Preview = () => {
  return (
    <div
      id='libraryBusinessFolderPreview'
      role='dialog'
      onKeyDown={(e) => e.stopPropagation()}
      className={styles.template_preview_container}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <p id='libraryBusinessFolderPreviewText'>
        This is where you will find your business documents. Any business documents you upload or
        create on the platform will be stored here.
      </p>
    </div>
  );
};

export default Preview;
